import regularUrl from "../../assets/fonts/Outfit-Regular.ttf?url";
import semiboldUrl from "../../assets/fonts/Outfit-SemiBold.ttf?url";
import type { PdfFontBytes } from "./model.js";

let cachedFonts: PdfFontBytes | undefined;
let fontLoadPromise: Promise<PdfFontBytes> | undefined;

function errorReason(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}

async function fetchFont(url: string): Promise<Uint8Array> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Font request failed (${response.status})`);
  }
  return new Uint8Array(await response.arrayBuffer());
}

/** Cached across calls. Returns null font bytes when fetching fails. */
export async function loadPdfFonts(): Promise<PdfFontBytes> {
  if (cachedFonts) return cachedFonts;
  if (fontLoadPromise) return fontLoadPromise;

  fontLoadPromise = Promise.all([fetchFont(regularUrl), fetchFont(semiboldUrl)])
    .then(([regular, semibold]) => ({ regular, semibold }))
    .catch((error) => {
      console.warn({
        event: "pdf.fontLoadFailed",
        reason: errorReason(error),
      });
      return { regular: null, semibold: null };
    })
    .then((fonts) => {
      cachedFonts = fonts;
      return fonts;
    });

  return fontLoadPromise;
}
